/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type HandoffApplicantDto = {
    /**
     * Applicant first name
     */
    first_name: string;
    /**
     * Applicant last name
     */
    last_name?: string;
    /**
     * Applicant email
     */
    email: string;
    /**
     * Country code with + prefix. Required unless `phone` is sent combined.
     */
    phone_country_code?: string;
    /**
     * Phone number without country code. Required unless `phone` is sent combined.
     */
    phone_number?: string;
    /**
     * Full number in E.164, as an alternative to sending the code and number separately.
     */
    phone?: string;
    /**
     * Dial code as sent by the partner form. Alias for phone_country_code.
     */
    phone_dial_code?: string;
    /**
     * National number as sent by the partner form. Alias for phone_number.
     */
    phone_national?: string;
    /**
     * ISO 3166-1 alpha-2 country of the number. Recorded but not authoritative.
     */
    phone_country_iso2?: string;
    /**
     * The partner's own id for this submission. Sending it again returns the reference we already issued rather than creating a second applicant.
     */
    event_id?: string;
    /**
     * City or area
     */
    city?: string;
    /**
     * Expert discipline, taken from the landing page the form sits on. The underscored form (personal_trainer) is also accepted.
     */
    discipline: HandoffApplicantDto.discipline;
    /**
     * Campaign parameters captured on the landing page
     */
    utm?: Record<string, any>;
    /**
     * Originating path or referrer
     */
    source?: string;
};
export namespace HandoffApplicantDto {
    /**
     * Expert discipline, taken from the landing page the form sits on. The underscored form (personal_trainer) is also accepted.
     */
    export enum discipline {
        PERSONAL_TRAINER = 'personal-trainer',
        PHYSIOTHERAPIST = 'physiotherapist',
        PSYCHOLOGIST = 'psychologist',
        TRAINED_LISTENER = 'trained-listener',
    }
}

